// extracted by mini-css-extract-plugin
export var copyableField = "_p1-4";
export var customerBadge = "_p1-0";
export var customerInfoTitle = "_p1-2";
export var details = "_p1-1";
export var dropdownContainer = "_p1-5";
export var dropdownImage = "_p1-6";
export var editAssigneeForm = "_p1-a";
export var editButton = "_p1-3";
export var email = "_p1-7";
export var hidden = "_p1-d";
export var input = "_p1-8";
export var saveButton = "_p1-b";
export var shopifyIcon = "_p1-c";
export var suggestionBadge = "_p1-e";
export var suggestionText = "_p1-f";
export var username = "_p1-9";